import { features } from "./features"
import { screens } from "./screens"
import { global } from "./global"
export let appState = { features, screens, global }
